import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=d133f68a&scoped=true"
import script from "./dataAnalysis.vue?vue&type=script&lang=js"
export * from "./dataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=d133f68a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d133f68a",
  null
  
)

export default component.exports